export const config = {
  gatewayScriptUrl: process.env.REACT_APP_PAYMENT_GATEWAY_SCRIPT_URL,
  gatewayMerchantCode: process.env.REACT_APP_PAYMENT_GATEWAY_MERCHANT_CODE,
  gatewayPublicKey: process.env.REACT_APP_PAYMENT_GATEWAY_PUBLIC_KEY
};
